import React, { Component } from "react";

export default class Signbutton extends Component {
  render() {
    const { width, disabled, onClick, padding, marginTop,fontSize } = this.props;
    return (
      <div style={this.props.customStyle} className="button-margin">
        <button
          className="login-button-sign-in"
          onClick={onClick}
          disabled={disabled}
          style={{
            padding: padding,
            width: width ? width : "100%",
            marginTop: marginTop ? marginTop : 30,
            fontSize:fontSize
          }}
        >
          {this.props.buttontitle}
        </button>
      </div>
    );
  }
}
export class Debtbutton extends Component {
  render() {
    return (
      <div>
        <button
          disabled={this.props.disabled}
          className={
            this.props.active
              ? "login-button-debt-button-active"
              : "login-button-debt-button"
          }
          style={{ width: this.props.width ? this.props.width : 120 }}
          onClick={this.props.onClick}
        >
          {this.props.buttontitle}
        </button>
      </div>
    );
  }
}

export class DebtbuttonActive extends Component {
  render() {
    return (
      <div>
        <button
          className="login-button-debt-button-active"
          onClick={this.props.onClick}
          style={{ outline: 0,width:!!this.props.width?this.props.width:135 }}
        >
          {this.props.buttontitle}
        </button>
      </div>
    );
  }
}

export class DebtbuttonNowidth extends Component {
  render() {
    return (
      <div>
        <button
          className="login-button-debt-button-active-no-width"
          onClick={this.props.onClick}
        >
          {this.props.buttontitle}
        </button>
      </div>
    );
  }
}
